import { Fragment } from "react";
import { CompanyEntryDto } from "@advanced-sales-technologies/backend-client/models/CompanyEntryDto";
import { ColumnDef } from "@tanstack/react-table";
import { TFunction } from "i18next";
import { HiOutlineWindow } from "react-icons/hi2";

import BaseColumn from "@/components/molecules/table/BaseColumn";
import { searchColumns } from "@/components/organisms/search/searchColumns";

const domainsColumn = (t: TFunction): ColumnDef<CompanyEntryDto> =>
  BaseColumn<CompanyEntryDto>({
    accessorFn: (row) => row.info.domains.map((value) => value).join(", "),
    id: searchColumns(t).domains.id,
    header: () => searchColumns(t).domains.name,
    cell: ({ row }) => {
      const domains = row.original.info.domains;
      return domains.map((domain, index) => {
        const formattedDomain =
          domain.startsWith("http://") || domain.startsWith("https://") ? domain : `https://${domain}`;

        return (
          <Fragment key={index}>
            <a href={formattedDomain} target="_blank" rel="noreferrer" className={"text-link-gray ml-1 underline"}>
              {domain}
            </a>
            {index < domains.length - 1 && ","}
          </Fragment>
        );
      });
    },
    meta: {
      heading: {
        icon: HiOutlineWindow,
      },
    },
  });

export default domainsColumn;
